// Editor de template em CONTEXTO DE EVENTO (§4.5 — rota
// …/configurations/:whiteLabelId/template-configuration/:templateId).
// Mesmo editor do contexto livre; aqui o cabeçalho evidencia o
// evento/WL que usa o template (usedBy do contrato GET versions).
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { TemplateEditorWorkspace } from "@/features/notification-center"

export function NotificationTemplateConfigurationPage() {
  const { t } = useTranslation()
  const { whiteLabelId, templateId } = useParams<{
    whiteLabelId: string
    templateId: string
  }>()
  const links = [
    {
      href: FRONTEND_ROUTES.DASHBOARD.href,
      label: t("sidebar.dashboard"),
    },
    {
      label: t("pages.notificationCenter.title"),
      href: FRONTEND_ROUTES.NOTIFICATION_CENTER.href,
    },
    {
      label: t("pages.notificationCenter.configurations"),
      href: FRONTEND_ROUTES
        .NOTIFICATION_CENTER_CONFIGURATIONS.href,
    },
    {
      label: t(
        "pages.notificationCenter.configurationsDetailPage.breadcrumb"
      ),
      // Rota REAL do detalhe do white label
      // (/notification-center/configurations/:whiteLabelId).
      href: `${FRONTEND_ROUTES.NOTIFICATION_CENTER_CONFIGURATIONS.href}/${whiteLabelId}`,
    },
    {
      label: t(
        "pages.notificationCenter.templateConfigurationBreadcrumb"
      ),
    },
  ]
  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb links={links} />
      </Header>
      <section className="flex flex-1 flex-col gap-4 p-4 @container">
        {templateId && (
          <TemplateEditorWorkspace
            templateUuid={templateId}
            context="event"
            whiteLabelId={whiteLabelId}
          />
        )}
      </section>
    </main>
  )
}
